/** Shapes more than one certificate design draws. */

/** Points of a star centred on the origin, starting straight up, for an SVG polygon. */
export function starPoints(points: number, outer: number, inner: number): string {
  return Array.from({ length: points * 2 }, (_, i) => {
    const radius = i % 2 === 0 ? outer : inner;
    const angle = (Math.PI / points) * i - Math.PI / 2;
    return `${radius * Math.cos(angle)},${radius * Math.sin(angle)}`;
  }).join(" ");
}

export type Point = { x: number; y: number };

/**
 * Evenly spaced points round a rectangle `inset` in from the page edge, about
 * `spacing` apart, starting at its top-left corner.
 */
export function pointsAround(
  width: number,
  height: number,
  inset: number,
  spacing: number,
): Point[] {
  const corners: Point[] = [
    { x: inset, y: inset },
    { x: width - inset, y: inset },
    { x: width - inset, y: height - inset },
    { x: inset, y: height - inset },
  ];
  return corners.flatMap((corner, i) => {
    const next = corners[(i + 1) % corners.length];
    const length = Math.hypot(next.x - corner.x, next.y - corner.y);
    const steps = Math.max(1, Math.round(length / spacing));
    // Each edge stops short of its last corner; the next edge starts there.
    return Array.from({ length: steps }, (_, j) => ({
      x: corner.x + ((next.x - corner.x) * j) / steps,
      y: corner.y + ((next.y - corner.y) * j) / steps,
    }));
  });
}
